export default {
  estimatedPrice: 'Szacunkowa cena przepakowania (za 1 sztukę mixa)',
  submitForm: 'Wypełnij formularz kontaktowy',
  goToSummary: 'Przejdź do podsumowania',
  modify: 'zmień',
  quantity: 'szt / opak.',
  attach: 'Dodaj załącznik',
  chosenTastes: 'Wybrane smaki',
  chosenCategory: 'Wybrany produkt',
  heading: 'Podsumowanie zamówienia',
  customHeading: 'Niestandardowe zamówienie',
  subheading: 'Sprawdź czy wszystko się zgadza',
  chosenBonuses: 'Wybrane dodatki',
  comment: 'Opisz swoje zamówienie',
  infoDesc: 'Podaj nam ilość wolumenu jaką planujesz przepakować, a my przygotujemy dla Ciebie specjalną ofertę.',
  noExtra: 'Brak dodatku',
};
